"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatEventListeners = void 0;
const next_i18next_1 = require("next-i18next");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
const useChatEventListeners = () => {
    const { t } = (0, next_i18next_1.useTranslation)('common');
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        let oTimer = null;
        window.olark('api.chat.onMessageToOperator', function () {
            window.olark('api.visitor.getDetails', function (details) {
                if (oTimer === null &&
                    !details.customFields.gotPleaseWait &&
                    details.customFields.firstMessageRcvd == 0) {
                    oTimer = setTimeout((() => {
                        // eslint-disable-next-line no-shadow
                        window.olark(`api.visitor.getDetails`, visitor => {
                            if (!visitor.customFields.gotPleaseWait &&
                                visitor.customFields.firstMessageRcvd == 0) {
                                window.olark('api.chat.sendMessageToVisitor', {
                                    body: t('chat.mPleaseHoldOn'),
                                });
                                window.olark('api.chat.sendNotificationToOperator', {
                                    body: t('chat.mPleaseHoldOn'),
                                });
                            }
                        });
                    }), 30 * 1000);
                }
            });
        });
        window.olark('api.chat.onMessageToVisitor', function (event) {
            if (event.message.automated) {
                const checkMessageBodyLang = (lang) => event.message.body == t('chat.mPleaseHoldOn', { lng: lang });
                if (fdr_lib_i18n_lang_config_1.languageList.some(checkMessageBodyLang)) {
                    window.olark('api.visitor.getDetails', function (details) {
                        window.olark('api.visitor.updateCustomFields', {
                            firstMessageSent: details.customFields.firstMessageSent,
                            firstMessageRcvd: details.customFields.firstMessageRcvd,
                            gotPleaseWait: true,
                        });
                    });
                }
            }
            else {
                oTimer && clearTimeout(oTimer);
                oTimer = null;
                window.olark('api.visitor.getDetails', function (details) {
                    window.olark('api.visitor.updateCustomFields', {
                        firstMessageSent: details.customFields.firstMessageSent,
                        firstMessageRcvd: Math.floor(new Date().getTime() / 1000),
                        gotPleaseWait: details.customFields.gotPleaseWait,
                    });
                });
            }
        });
    }, [t]);
};
exports.useChatEventListeners = useChatEventListeners;
//# sourceMappingURL=useChatEventListeners.js.map